import { getApiInternalClient } from '..';
import getSession from '../../utilities/getSession';
import withAuthenticationHeaders from '../../utilities/withAuthenticationHeaders';

export default function fetchInternalPaymentRequest(
  id: string,
): Promise<io.flow.internal.v0.models.InternalPaymentRequest> {
  return getSession().then((session) => getApiInternalClient().paymentRequest.get({
    id,
    organization: session.organization,
    headers: withAuthenticationHeaders(session.id),
  }).then((response) => {
    if (response.ok) {
      return response.body;
    }
    throw new Error(`fetchPaymentRequest: Error fetching PR id [${id}]; status: ${response.status}`);
  }));
}
